var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedemption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.991 23.2812H14.0176C11.9299 23.2812 10.2375 24.9736 10.2375 27.0613V49.83C10.2375 51.9176 11.9299 53.61 14.0176 53.61H49.991C52.0786 53.61 53.771 51.9176 53.771 49.83V27.0613C53.771 24.9736 52.0786 23.2812 49.991 23.2812Z",
    fill: "url(#paint0_linear_6678_34720)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1896 17.6016H10.8219C9.55801 17.6016 8.53345 18.6261 8.53345 19.89V24.9371C8.53345 26.201 9.55801 27.2255 10.8219 27.2255H53.1896C54.4535 27.2255 55.4781 26.201 55.4781 24.9371V19.89C55.4781 18.6261 54.4535 17.6016 53.1896 17.6016Z",
    fill: "#FFC3F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2388 53.5623L32.2388 16.5723",
    stroke: "#002C50",
    strokeWidth: 2.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5948 16.4627C31.9689 14.6829 27.3481 8.71829 25.2189 11.308C22.6728 14.4048 30.2139 17.3829 31.5948 16.4627Z",
    stroke: "#002C50",
    strokeWidth: 2.16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1254 16.4627C31.7513 14.6829 36.3721 8.71829 38.5013 11.308C41.0474 14.4048 33.5063 17.3829 32.1254 16.4627Z",
    stroke: "#002C50",
    strokeWidth: 2.16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6678_34720",
    x1: 37.1535,
    y1: 51.1656,
    x2: 28.9336,
    y2: 25.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemption);
export default __webpack_public_path__ + "static/media/Redemption.4323b4a72db00ce79c9bfd85729a42fc.svg";
export { ForwardRef as ReactComponent };